import { HttpResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ViajesService } from 'src/app/_services/viajes.service';
import { ModalMsgComponent } from '../modal-msg/modal-msg.component';
import { AgenciasService } from '../../_services/agencias.service';
import { AuxiliarService } from 'src/app/_services/auxiliar.service';

@Component({
  selector: 'app-modal-confirm-pasajero-delete',
  templateUrl: './modal-confirm-pasajero-delete.component.html',
  styleUrls: ['./modal-confirm-pasajero-delete.component.css']
})
export class ModalConfirmPasajeroDeleteComponent implements OnInit {

  @Input() id: string;

  constructor(
    public activeModal: NgbActiveModal,
    private router: Router,
    private modalService: NgbModal,
    private agenciasService:AgenciasService,
    private auxService:AuxiliarService
  ) { }

  ngOnInit(): void {    
  }

  aceptar(){
    this.agenciasService.cancelarPasajero(+this.id).subscribe((data)=>{
      if(data instanceof HttpResponse) { 
        //verificar token
        if(data.body.msg === 'TOKEN_INVALID' || data.body.msg === 'TOKEN_IS_NOT_FOUND') {
          this.auxService.sessionExpired();
        }
        //acciones  
        this.modalService.dismissAll('Cross click');
        const modalRef = this.modalService.open(ModalMsgComponent, { 
          centered: true,  
          backdrop:'static',      
        });
        modalRef.componentInstance.label = 'Volver'; 
        if(data.body.msg === 'PASAJERO_DELETE_SUCCESS')  {          
          modalRef.componentInstance.titulo = 'Pasajero eliminado';
          modalRef.componentInstance.check = 1; 
        } else {
          modalRef.componentInstance.check = 0;    
          modalRef.componentInstance.titulo = 'Ha ocurrido un error';  
        } 
        this.redirectTo(this.router.url); 
      }
    })
  }

  cancelar(){
    this.activeModal.dismiss('Cross click');
  }

  redirectTo(uri) {
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() =>
    this.router.navigate([uri]));
  }

}
